module.exports = __webpack_public_path__ + "img/frame.2e2c9967.png";